import { ExportCentralAssortmentItems } from '@retail/my-assortment/types';
import { AppTFunction } from '@retail/app/i18n';
import { CentralAssortmentExportColumn } from './centralAssortmentColumnHeaders';
import { getISO_8601Date } from '@retail/utils';

type AssortmentValueGetter = (
  assortmentItem: ExportCentralAssortmentItems,
  t: AppTFunction
) => string | number | null | undefined;

export const centralAssortmentValueMap: Record<
  CentralAssortmentExportColumn,
  AssortmentValueGetter
> = {
  inAssortment: (item, t) => (item.inAssortment ? t('common.yes') : t('common.no')),
  mgItemNumber: (item) => item.mgItemNumber,
  finfoNumber: (item) => item.finfoNumber,
  nobbNumber: (item) => item.nobbNumber,
  primaryGtin: (item) => item.primaryGtin,
  primaryText: (item) => item.primaryText,
  secondaryText: (item) => item.secondaryText,
  supplierNumber: (item) => item.supplier.id,
  supplierName: (item) => item.supplier.name,
  productGroupNumber: (item) => item.productGroup.groupNumber,
  productGroupName: (item) => item.productGroup.name,
  priority: (item, t) => (item.priority.prioritised ? t('common.yes') : t('common.no')),
  priorityValidFrom: (item) => getISO_8601Date(item.priority.validFrom),
  priorityValidTo: (item) => (item.priority.validTo ? getISO_8601Date(item.priority.validTo) : ''),
  discontinuationDate: (item) =>
    item.discontinuationDate ? getISO_8601Date(item.discontinuationDate) : '',
  discontinuationStatus: (item) => item.discontinuationStatus,
  assortmentTag: (item) => item.assortmentTag ?? '',
  tagFrom: (item) => (item.tagFrom ? getISO_8601Date(item.tagFrom) : ''),
  tagTo: (item) => (item.tagTo ? getISO_8601Date(item.tagTo) : ''),
  addedBy: (item) =>
    item.createdBy ? `${item.createdBy.givenName} ${item.createdBy.familyName}` : '',
};
